module.exports = __webpack_public_path__ + "media/images/flags/32/Pakistan-05b4e624602d45bcf0d2a1c605876d1c.png";